import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import {APIProvider} from "@vis.gl/react-google-maps";
import {Toaster} from "react-hot-toast";
import {IntlProvider} from "react-intl";
import {BrowserRouter} from "react-router-dom";
import {GeolocationProvider} from "@/features/geolocation";
import {getLanguage, getMessages} from "@/translations";

const queryClient = new QueryClient();

export function AppProviders({children}: {children: React.ReactNode}) {
    return (
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <IntlProvider locale={getLanguage()} messages={getMessages()}>
                    <GeolocationProvider>
                        <APIProvider apiKey={window.appConfig?.googleMapsKey || ""}>
                            {children}
                            <Toaster position="bottom-center" />
                        </APIProvider>
                    </GeolocationProvider>
                </IntlProvider>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </BrowserRouter>
    );
}
